export const getToplisteStoryName = (name: string) => {
  /** name comes in format like this "Topliste: Heisse Hingucker"
   *  we need to get part after ":"
   */
  return name.includes(':') ? name.split(':')[1]?.trim() : name;
};
